import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  MultiSelect,
  rem,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import {
  IconBarcode,
  IconFileExport,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { InventoryItem } from "../../../model/TblInventorySerialOnhandByBranch";

const InventorySerialOnhandByBranch = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<InventoryItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);

  // Mã chủng
  const [searchCatSegment4d, setSearchCatSegment4d] = useState<string>("");
  const [debounceCatSegment4d] = useDebouncedValue<string>(
    searchCatSegment4d,
    500,
  );
  const [dataCatSegment4d, setDataCatSegment4d] = useState<
    SelectListItemModel[]
  >([]);
  // Mã nghành
  const [dataCatSegment2b, setDataCatSegment2b] = useState<
    SelectListItemModel[]
  >([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<
    SelectListItemModel[]
  >([]);
  // Mã nhóm
  const [searchCatSegment5e, setSearchCatSegment5e] = useState<string>("");
  const [debounceCatSegment5e] = useDebouncedValue<string>(
    searchCatSegment5e,
    500,
  );
  const [dataCatSegment5e, setDataCatSegment5e] = useState<
    SelectListItemModel[]
  >([]);

  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };
  const formSeachInput = useForm<{
    KeySearch: string;
    MaChung: string[];
    MaLoai: string[];
    MaNhom: string[];
    MaNganh: string[];
  }>({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: "",
      MaChung: [],
      MaLoai: [],
      MaNhom: [],
      MaNganh: [],
    },
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;
    if (formSeachInput.getValues().KeySearch) {
      url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
    }
    if (formSeachInput.getValues().MaChung?.length > 0) {
      formSeachInput.getValues().MaChung.forEach((maChung) => {
        url += `&MaChung=${maChung}`;
      });
    }
    if (formSeachInput.getValues().MaNhom?.length > 0) {
      formSeachInput.getValues().MaNhom.forEach((maNhom) => {
        url += `&MaNhom=${maNhom}`;
      });
    }
    if (formSeachInput.getValues().MaNganh?.length > 0) {
      formSeachInput.getValues().MaNganh.forEach((maNganh) => {
        url += `&MaNganh=${maNganh}`;
      });
    }
    if (formSeachInput.getValues().MaLoai?.length > 0) {
      formSeachInput.getValues().MaLoai.forEach((maLoai) => {
        url += `&MaLoai=${maLoai}`;
      });
    }
    try {
      const response = await repositoryMdm.get(
        `/api/v1/VInventorySerialOnhandByBranchRp/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<InventoryItem>[]>(
    () => [
      {
        accessorKey: "maVt",
        header: "Mã vật tư",
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="dot"
              radius="xs"
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "tenVt",
        header: "Tên vật tư",
        size: 300,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
      },
      {
        accessorKey: "maLoai",
        header: "Mã loại",
      },
      {
        accessorKey: "tenLoai",
        header: "Tên loại",
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        header: "Tổng số lượng",
        accessorKey: "totalQuantity",
        Cell: ({ row }) => {
          const tonKeys = [
            "ton101",
            "ton102",
            "ton103",
            "ton104",
            "ton105",
            "ton106",
            "ton107",
            "ton108",
            "ton109",
            "ton110",
            "ton111",
            "ton112",
            "ton113",
            "ton114",
            "ton115",
            "ton116",
            "ton117",
            "ton118",
            "ton119",
            "ton120",
            "ton121",
            "ton122",
            "ton123",
            "ton131",
            "ton132",
          ];

          if (!row.original || typeof row.original !== "object") {
            console.error("Lỗi: row.original không hợp lệ!", row.original);
            return <>0</>;
          }

          const totalQuantity = tonKeys.reduce((acc, key) => {
            const value = (row.original as any)[key];
            return acc + (typeof value === "number" ? value : 0);
          }, 0);

          return <>{totalQuantity}</>;
        },
      },
      {
        accessorKey: "ton101",
        header: "01_Hai Bà Trưng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton102",
        header: "02_Đống Đa",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton103",
        header: "03_Hải Phòng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton104",
        header: "04_Cầu Giấy",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton105",
        header: "05_Hà Đông 1",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton106",
        header: "06_Long Biên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton107",
        header: "07_Đông Anh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton108",
        header: "08_Hà Đông 2",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton109",
        header: "09_Bắc Giang",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton110",
        header: "10_Phủ Lý",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton111",
        header: "11_Vinh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton112",
        header: "12_Thái Nguyên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton113",
        header: "13_Thanh Hóa",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton114",
        header: "14_Hoàng Mai",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton115",
        header: "15_Kho HUB",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton116",
        header: "16_Cầu Giấy 2",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton117",
        header: "17_Ocean Park",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton118",
        header: "18_Gia Lâm 2",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton119",
        header: "19_Thủ Đức",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton120",
        header: "20_Gò Vấp",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton121",
        header: "21_Q3-HCM",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton122",
        header: "22_Từ Sơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton123",
        header: "23_Thanh Trì",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton131",
        header: "31_Dịch Vụ Tốt Thái Hà",
        size: 200,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton132",
        header: "32_Dịch Vụ Tốt Cầu Giấy",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
    ],
    [],
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowNumbers: true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
        display: "none",
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers", "maVt"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  // ExportData Excel
  const exportDataExcel = async () => {
    open();
    try {
      let params = new URLSearchParams();
      const keySearch = formSeachInput.getValues().KeySearch;
      if (keySearch) params.append("KeySearch", keySearch);

      const maChung = formSeachInput.getValues().MaChung;
      if (maChung && maChung.length > 0) {
        maChung.forEach((item) => {
          params.append("MaChung", item);
        });
      }
      const maNhom = formSeachInput.getValues().MaNhom;
      if (maNhom && maNhom.length > 0) {
        maNhom.forEach((item) => {
          params.append("MaNhom", item);
        });
      }
      const maNganh = formSeachInput.getValues().MaNganh;
      if (maNganh && maNganh.length > 0) {
        maNganh.forEach((item) => {
          params.append("MaNganh", item);
        });
      }
      const maLoai = formSeachInput.getValues().MaLoai;
      if (maLoai && maLoai.length > 0) {
        maLoai.forEach((item) => {
          params.append("MaLoai", item);
        });
      }
      const url = `${BASE_API_MDM}/api/v1/ExportExcel/export-bao-cao-ton-kho-theo-chi-nhanh${
        params.toString() ? `?${params.toString()}` : ""
      }`;
      const token = localStorage.getItem("token")?.replace(/"/g, "");

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });

      if (!response.ok) throw new Error("Failed to dowload file");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "bao-cao-ton-kho-theo-chi-nhanh.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      close();
    }
  };

  // Call api lấy dữ liệu mã chủng
  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=20";

    if (searchCatSegment4d && searchCatSegment4d.length > 0) {
      url += `&CodeString=${searchCatSegment4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      const uniqueData = Array.from(
        new Set(dataAPI.map((item: any) => item.value)),
      ).map((value) => dataAPI.find((item: any) => item.value === value));
      setDataCatSegment4d([...dataCatSegment4d, ...uniqueData]);
    }
  };

  // Call api lấy dữ liệu mã ngành
  const fetchCatSegment2b = async () => {
    let url = "/api/v1/TblCatSegment2b/get-all";

    const res = await repositoryPos.get<MessageResponse<any>>(url);
    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment2b(dataAPI);
    }
  };

  const getCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment3c(data);
    }
  };

  // Call api lấy dữ liệu mã nhóm
  const fetchCatSegment5e = async () => {
    let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=20";
    if (searchCatSegment5e && searchCatSegment5e.length > 0) {
      url += `&CodeString=${searchCatSegment5e}`;
    }
    const res = await repositoryPos.get<MessageResponse<any>>(url);
    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      const uniqueData = Array.from(
        new Map(
          [...dataCatSegment5e, ...dataAPI].map((item) => [item.value, item]),
        ).values(),
      );
      setDataCatSegment5e(uniqueData);
    }
  };
  // mã chủng
  useEffect(() => {
    if (debounceCatSegment4d && debounceCatSegment4d.length > 4) {
      fetchCatSegment4d();
    }
  }, [debounceCatSegment4d]);
  // mã ngành
  useEffect(() => {
    fetchCatSegment2b();
    getCatSegment3c();
  }, []);
  // mã nhóm
  useEffect(() => {
    if (debounceCatSegment5e && debounceCatSegment5e.length > 2) {
      fetchCatSegment5e();
    }
  }, [debounceCatSegment5e]);

  useEffect(() => {
    fetchData();
  }, [pagination]);

  let params = new URLSearchParams();

  //     // Add the query parameters if they exist
  const keySearch = formSeachInput.getValues().KeySearch;
  if (keySearch) {
    params.append("KeySearch", keySearch);
  }

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          justify="space-between"
          align="center"
          style={{
            border: "1px solid #dee2e6",
            padding: "5px 10px",
          }}
        >
          <BreadcrumbLayout1></BreadcrumbLayout1>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>

        <Grid mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã ngành"
              clearable
              searchable
              data={dataCatSegment2b}
              value={formSeachInput.getValues().MaNganh}
              onChange={(value) =>
                formSeachInput.setFieldValue("MaNganh", value)
              }
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Mã loại"
              data={dataCatSegment3c}
              leftSection={<IconPackage color="#15aabf" />}
              searchable
              clearable
              value={formSeachInput.getValues().MaLoai}
              onChange={(value) =>
                formSeachInput.setFieldValue("MaLoai", value)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã nhóm"
              clearable
              searchable
              searchValue={searchCatSegment5e}
              onSearchChange={setSearchCatSegment5e}
              data={dataCatSegment5e}
              value={formSeachInput.getValues().MaNhom}
              onChange={(value) =>
                formSeachInput.setFieldValue("MaNhom", value)
              }
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã chủng"
              clearable
              searchable
              searchValue={searchCatSegment4d}
              onSearchChange={(e) => setSearchCatSegment4d(e)}
              data={dataCatSegment4d}
              value={formSeachInput.getValues().MaChung}
              onChange={(value) => {
                formSeachInput.setFieldValue("MaChung", value);
              }}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default InventorySerialOnhandByBranch;
